import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class SetCursorPositionRightCommand extends Plugin {

  constructor(editor) {
    super(editor);
    this.refresh();
  }

  execute({ id }) {
    const editor = this.editor;
    const range = editor.model.createRangeIn(editor.model.document.getRoot());
    for (const item of range.getItems({ ignoreElementEnd: true })) {
      if ((item.name == 'numberedcitation' || item.name == 'video') && item.getAttribute('id') === id) {
        editor.model.change(writer => {
          document.getElementById(`${id}`).click();
          const afterPos = writer.createPositionAfter(item);
          writer.setSelection(afterPos);
        });
      }
    }
  }

  refresh() {
  }
}